import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { IOSSwitch } from '../IOSSwitch';

interface RouterGeoVisibilityEditProps {
  onSubmit: () => void;
  cpeId: string;
  geoEnabled: boolean;
}
export const RouterGeoVisibilityEdit = ({ onSubmit, cpeId, geoEnabled }: RouterGeoVisibilityEditProps) => {
  const api = useApi();
  const [newGeoEnabled, setNewGeoEnabled] = useState<boolean>(geoEnabled);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewGeoEnabled(e.target.checked);
    setDisableSubmit(e.target.checked === geoEnabled);
  };

  const editGeo = useMutation(api.toggleCpeGeoVisibilityApiV1ToggleCpeGeoVisibilityPost, {
    onSuccess() {
      toast.success(`${newGeoEnabled ? 'Enabled' : 'Disabled'} geo visibility successfully.`);
      onSubmit();
    },
    onError: (error) => {
      apiError(error);
      setDisableSubmit(false);
    },
  });

  const handleSubmit = () => {
    setDisableSubmit(true);
    editGeo.mutate({
      cpe_id: cpeId,
      enabled: newGeoEnabled || false
    });
  };

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
        Enable or disable Geo Visibility to see where data traffic is globally originated and destined.
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControlLabel
          value="top"
          control={
            <IOSSwitch color="primary" checked={newGeoEnabled} onChange={handleChange} />
          }
          label={newGeoEnabled ? 'Enabled' : 'Disabled'}
          labelPlacement="bottom"
          sx={(theme) => ({ '&:hover': { color: theme.palette.primary.main } })}
          componentsProps={{
            typography: {
              sx: (theme) => ({
                fontSize: 12,
                color: !newGeoEnabled ? theme.palette.grey[600] : theme.palette.primary.main,
              }),
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={disableSubmit}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
